export { default } from './exactProp';